
export default class FeeAnswersViewModel {
    

    public governmentFunded: boolean | undefined = undefined;
    public fullFeesDue: boolean | undefined = undefined;
    public shouldNotHappen: boolean | undefined = undefined;
     // fees
    public mandeGradeCOrAbove: boolean | undefined = undefined;
    public achBeforeApril: boolean | undefined = undefined;
    public completedL2OrAbove: boolean | undefined = undefined;
    public completedCourseLevelOrAbove: boolean | undefined = undefined;
    public areYouWorking: boolean | undefined = undefined;
    public earnLessThan17K: boolean | undefined = undefined;
    public universalCredit: boolean | undefined = undefined;
    public universalCreditLowerIncome: boolean | undefined = undefined;
    public jsaOrEsa: boolean | undefined = undefined;
    public otherBenefitsLowIncome: boolean | undefined = undefined;
    public haveYouAppliedLl: boolean | undefined = undefined;
    public sustainable: boolean | undefined = undefined;
    public studentResultAnswer: string | undefined = undefined;
    public hcukResultAnswer: string | undefined = undefined;
    public studentAcceptedFees: boolean | undefined = undefined;

    public dummy: boolean = true;
} 